import React from 'react'; 
import WithConsumer from '../../context/WithConsumer';
import Gallery from '../global/Gallery';
import ProjectForm from './ProjectForm';
import { Link } from 'react-router-dom';
import Footer from '../global/Footer';

const Project = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    const ctxPageLoadDone = () => context.pageLoadDone;
    const pageLoadDone = ctxPageLoadDone();
    
	function handleToggle(evt) {
	    evt.preventDefault();
	    document.documentElement.classList.add('state-popup-open');
    }
    
    if (post) {

	    let pageClass = 'c-page c-page--space c-page--' + post.slug;
	    
	    if (pageLoaded) {
		    pageClass = pageClass + ' state-page-loaded';
	    }
	    	    	        							
		if (context.appError){
		
			return null; 
		
		} else {
			
			return (
				
				<div className={pageClass}>
					
					<div className="c-page__inner">
						
						<div id="single-project" className="c-page__block c-page__block--cream">
	    
					    	<div className="c-page__block__inner c-page__block__inner--small-margins">
					    			    		
					    		<div className="c-project">
					    		
					    			<div className="c-project__columns">
					    		
						    			<div className="c-project__column">
						    			
						    				<div className="c-project__column__top">
						    										    									    					
						    					{post.heading && post.suburb &&
						    						<h1 className="c-project__heading" dangerouslySetInnerHTML={{__html:post.heading + ' – ' + post.suburb}}></h1>
						    					}
						    					
						    					{post.heading && !post.suburb &&
						    						<h1 className="c-project__heading" dangerouslySetInnerHTML={{__html:post.heading}}></h1>
						    					}
						    					
						    					<div className="c-project__info">
						    						{post.address &&
							    						<div className="c-project__info__row">
							    							<h5 className="c-project__info__row__label" dangerouslySetInnerHTML={{__html:'Address'}}></h5>
							    							<p className="c-project__info__row__value" dangerouslySetInnerHTML={{__html:post.address}}></p>
							    						</div>
						    						}
						    						{post.type &&
							    						<div className="c-project__info__row">
							    							<h5 className="c-project__info__row__label" dangerouslySetInnerHTML={{__html:'Type'}}></h5>
							    							<p className="c-project__info__row__value" dangerouslySetInnerHTML={{__html:post.type}}></p>
							    						</div>
						    						}
						    						{post.info &&
							    						<>
								    						{post.info.map((info,i) =>
																{
																	return (
																		<>
																			{info.label && info.value &&
																				<div className="c-project__info__row">
													    							<h5 className="c-project__info__row__label" dangerouslySetInnerHTML={{__html:info.label}}></h5>
													    							<p className="c-project__info__row__value" dangerouslySetInnerHTML={{__html:info.value}}></p>
													    						</div>
																			}
																		</>
																	)
																}
															)}
														</>
													}
						    						{post.status &&
							    						<div className="c-project__info__row">
							    							<h5 className="c-project__info__row__label" dangerouslySetInnerHTML={{__html:'Status'}}></h5>
							    							<p className="c-project__info__row__value" dangerouslySetInnerHTML={{__html:post.status}}></p>
							    						</div>
						    						}
						    					</div>
						    											    					
						    					<div className="c-project__buttons c-project__buttons--desktop">
						    					
						    						<a href={'#'} className="c-project__button" dangerouslySetInnerHTML={{__html:'Enquire'}} onClick={handleToggle}></a>
						    						
						    						<div className="c-project__buttons__clear"></div>
						    						
						    						{post.buttons &&
							    						<>
								    						{post.buttons.map((button,i) =>
																{
																	if (button.url.indexOf('http') !== -1) {
																		return (
																			<a href={button.url} className="c-project__button" dangerouslySetInnerHTML={{__html:button.text}}></a>
																		)
																	} else {
																		return (
																			<Link to={{ pathname: button.url }} className="c-project__button" dangerouslySetInnerHTML={{__html:button.text}}></Link>
																		)
																	}
																}
															)}
														</>
													}
						    						
						    					</div>
						    					
						    				</div>
						    											    				
						    				<div className="c-project__column__bottom c-project__column__bottom--desktop c-project__column__bottom-text">
						    					<Link to={{ pathname: '/projects/' }} className="c-project__back c-project__back--desktop" dangerouslySetInnerHTML={{__html:'Back to Projects Page'}}></Link>
						    				</div>
						    			
						    			</div>
										
										<div className="c-project__column">
										
											<div className="c-project__column__top">
											
												{post.text &&
													<div className="scope-page-text" dangerouslySetInnerHTML={{__html:post.text}}></div>												
												}
												
							    				<div className="c-project__buttons c-project__buttons--mobile">
						    					
						    						<a href={'#'} className="c-project__button" dangerouslySetInnerHTML={{__html:'Enquire'}} onClick={handleToggle}></a>
						    						
						    						<div className="c-project__buttons__clear"></div>
						    						
						    						{post.buttons &&
							    						<>
								    						{post.buttons.map((button,i) =>
																{
																	if (button.url.indexOf('http') !== -1) {
																		return (
																			<a href={button.url} className="c-project__button" dangerouslySetInnerHTML={{__html:button.text}}></a>
																		)
																	} else {
																		return (
																			<Link to={{ pathname: button.url }} className="c-project__button" dangerouslySetInnerHTML={{__html:button.text}}></Link>
																		)
																	}
																}
															)}
														</>
													}
						    						
						    					</div>
							    				
							    			</div>
							    			
							    			<div className="c-project__column__bottom">
							    			
							    				{post.gallery &&
						    												    				
							    					<div className="c-project__gallery">
							    						
							    						<Gallery gallery={post.gallery} loaded={pageLoadDone}></Gallery>
							    						
							    					</div>
								    												    				
							    				}
							    				
												<Link to={{ pathname: '/projects/' }} className="c-project__back c-project__back--mobile" dangerouslySetInnerHTML={{__html:'Back to Projects Page'}}></Link>
							    				
							    			</div>

										</div>
						    		
						    		</div>
						    		
						    	</div>
					    		
					    	</div>
					    					    
					    </div>
						
					</div>
					
					<Footer post={post}></Footer>
					
					<ProjectForm post={post}></ProjectForm>
					
				</div>
					
			)
				
		}
		
	} else {
		
		return null;
	
	}
};
export default WithConsumer(Project);